<template>
  <div class="bindTips">
    <div class="img">
      <img src="/resource/images/img_bindphone_holder.png"
           alt />
    </div>
    <div class="txt">
      <div class="colorfb674a item-1">绑定手机领</div>
      <div class="colorfb674a item-2">专属高额优惠券</div>
      <div class="item-3">您有一个手机绑定礼包未领取</div>
      <div class="item-4">
        <a href="javascript:;"
           class="btnNml btnGoBind"
           @click="fnBtnClick('bindPhoneStep')">绑定领取</a>
        <a href="javascript:;"
           class="btnBorder btnNextTime"
           @click="fnBtnClick('closeModal')">下次再说</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageClose',
  data () {
    return {
      name: '关闭前绑定手机提示'
    }
  },
  components: {
  },
  mounted () {
  },
  methods: {
    fnBtnClick (type) {
      this.$emit('fnBtnClick', type)
    }
  }
}
</script>

<style>
</style>
